module.exports = __webpack_public_path__ + "static/media/9.34df9e88.jpg";